function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "client",
  transform: "translate(-8 -8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_315",
  "data-name": "Path 315",
  d: "M37.587,22.551h-.494A14.063,14.063,0,0,0,23.521,8.979V8.485a.485.485,0,1,0-.97,0v.494A14.063,14.063,0,0,0,8.979,22.551H8.485a.485.485,0,1,0,0,.97h.494A14.063,14.063,0,0,0,22.551,37.093v.494a.485.485,0,1,0,.97,0v-.494A14.063,14.063,0,0,0,37.093,23.521h.494a.485.485,0,1,0,0-.97Zm-1.94.97h.475a13.093,13.093,0,0,1-12.6,12.6v-.475a.485.485,0,0,0-.97,0v.475a13.093,13.093,0,0,1-12.6-12.6h.475a.485.485,0,1,0,0-.97H9.95a13.093,13.093,0,0,1,12.6-12.6v.475a.485.485,0,1,0,.97,0V9.95a13.093,13.093,0,0,1,12.6,12.6h-.475a.485.485,0,0,0,0,.97Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_316",
  "data-name": "Path 316",
  d: "M120.837,180a1.94,1.94,0,1,0-3.155,0,2.968,2.968,0,0,0-1.154.869,3.367,3.367,0,0,0-1.29-1.145,2.425,2.425,0,1,0-4.044,0,3.378,3.378,0,0,0-1.19,1,2.961,2.961,0,0,0-1.031-.726,1.94,1.94,0,1,0-3.155,0A2.97,2.97,0,0,0,104,182.749v1.464a.485.485,0,0,0,.485.485h4.85v.485a.485.485,0,0,0,.485.485h6.791a.485.485,0,0,0,.485-.485V184.7h5.074a.485.485,0,0,0,.485-.485v-1.464A2.97,2.97,0,0,0,120.837,180Zm-13.442-2.1a.97.97,0,0,1,.1,1.935h-.2a.97.97,0,0,1,.1-1.935Zm1.94,4.85v.97H104.97v-.979a2,2,0,0,1,1.474-1.937h.814c.045,0,.091.005.138.005s.092,0,.138-.005h.814a2,2,0,0,1,1.164.865A3.422,3.422,0,0,0,109.335,182.757Zm3.88-5.82a1.455,1.455,0,1,1-1.455,1.455A1.455,1.455,0,0,1,113.216,176.937Zm2.91,7.761h-5.82v-1.94a2.435,2.435,0,0,1,.179-.919l.007-.018a2.414,2.414,0,0,1,1.459-1.361,2.418,2.418,0,0,0,2.529,0,2.418,2.418,0,0,1,1.645,2.3Zm3.134-6.791a.97.97,0,0,1,.1,1.935h-.2a.97.97,0,0,1,.1-1.935Zm2.425,5.82H117.1v-.97a3.434,3.434,0,0,0-.1-.825.5.5,0,0,0,.05-.079,2,2,0,0,1,1.264-1.042h.814c.045,0,.091.005.138.005s.092,0,.138-.005h.814a2,2,0,0,1,1.474,1.937Z",
  transform: "translate(-90.179 -157.781)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_317",
  "data-name": "Path 317",
  d: "M64.97,248h-.485a.485.485,0,1,0,0,.97h.485a.485.485,0,1,0,0-.97Z",
  transform: "translate(-52.605 -225.449)",
  fill: "#ac1ede"
}));

var SvgClient = function SvgClient(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.072,
    height: 30.072,
    viewBox: "0 0 30.072 30.072",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClient, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/client.9c14483d.svg";
export { ForwardRef as ReactComponent };